module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/reports/todays-opened-tickets/todays-opened-tickets.component.css
// module id = ./src/app/reports/todays-opened-tickets/todays-opened-tickets.component.css
// module chunks = main